import { render, staticRenderFns } from "./Add2.vue?vue&type=template&id=31b017cc"
import script from "./Add2.vue?vue&type=script&lang=js"
export * from "./Add2.vue?vue&type=script&lang=js"
import style0 from "./Add2.vue?vue&type=style&index=0&id=31b017cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports